import React from "react";
import PropTypes from "prop-types";

const AvatarMessage = ({ avatar, message }) => (
  <div>
    <div className="avatar-message-container">
      <div>
        <img src={avatar} alt="avatar" size="lg" />
      </div>
      <div className="message">{message}</div>
    </div>
  </div>
);

AvatarMessage.propTypes = {
  avatar: PropTypes.string,
  message: PropTypes.string
};

export default AvatarMessage;
